import React from 'react';
import cn from 'classnames';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import {CollapsiblePanel} from 'entities/tariff';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import TextAreaDomain from 'shared/ui/TextArea/TextAreaDomain';
import {TagsChipField, BatchResult} from 'entities/monitor';
import {NotifyChannels} from 'entities/notification';
import useDomainMonitorBatchCreateForm from 'features/domain/model/useDomainMonitorBatchCreateForm';

import DomainMonitorChecks from './DomainMonitorChecks/DomainMonitorChecks';

import styles from './DomainMonitorForm.module.scss';

interface IDomainMonitorBatchCreateFormProps {
    handleClose: () => void,
    // eslint-disable-next-line no-unused-vars
    onShowResultChange?: (isShowing: boolean) => void,
}

const DomainMonitorBatchCreateForm: React.FC<IDomainMonitorBatchCreateFormProps> = ({
    handleClose,
    onShowResultChange,
}) => {
    const {form, result, isLoading, progress, freeTariff, submit, handleCloseResult} =
        useDomainMonitorBatchCreateForm(handleClose, onShowResultChange);
    const {register, formState, control} = form;
    const {errors, isValid} = formState;

    return (
        <>
            {
                result
                    ? <BatchResult
                        result={result}
                        handleClose={handleCloseResult}
                        title={t`Мониторы доменов добавлены`}
                    />
                    : <form onSubmit={submit} className={styles.form}>
                        <ModalBodyWrapper>
                            <FormGroupWithError
                                error={errors?.domain?.message}
                                className={cn(styles.formGroup, styles.firstFormGroup)}
                            >
                                <TextAreaDomain
                                    rows={5}
                                    register={register}
                                    placeholder={t`Вводите каждый домен с новой строки`}
                                    name="domain"
                                />
                            </FormGroupWithError>

                            <TagsChipField
                                control={control}
                                label={t`Теги`}
                                error={errors?.tags?.message}
                                className={styles.formGroup}
                            />
                        </ModalBodyWrapper>

                        <ModalBodyWrapper>
                            <CollapsiblePanel
                                title={t`Проверки`}
                                defaultExpanded
                                className={styles.panel}
                                isFreeTariff={freeTariff}
                                premiumCondition="monitor_ssl_enabled"
                            >
                                <DomainMonitorChecks register={register}/>
                            </CollapsiblePanel>
                        </ModalBodyWrapper>

                        <ModalBodyWrapper>
                            <CollapsiblePanel
                                title={t`Уведомления`}
                                defaultExpanded={false}
                                className={styles.panel}
                            >
                                <NotifyChannels
                                    control={control}
                                    register={register}
                                    emailFieldName="notify_by_email"
                                    additionalEmailsFieldName="additional_emails"
                                    telegramFieldName="telegram_chats"
                                    maxFieldName="max_chats"
                                />
                            </CollapsiblePanel>
                        </ModalBodyWrapper>

                        <ModalBlockButton
                            primaryButtonText={t`Добавить`}
                            primaryButtonType="submit"
                            primaryButtonLoading={isLoading}
                            primaryButtonDisabled={!isValid}
                            secondaryButtonOnClick={handleClose}
                            progress={progress}
                        />
                    </form>
            }
        </>
    );
};

export default DomainMonitorBatchCreateForm;
